import { isAdminRole, isSupplierRole, isSupporterRole, rolesQuery } from "@/api/roles";
import { api, auth } from "@/api/utils";
import { Center, Spinner } from "@givenwell/components";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/")({
  component: Home,
  beforeLoad: async () => {
    if (auth.hasAccessToken()) {
      return;
    }
    try {
      await auth.renewAuthTokens(true);
      await api.auth.getManagementUserInfo();
    } catch (e) {}
  },
});

function Home() {
  const navigate = useNavigate();
  const roleQuery = useQuery(rolesQuery);

  useEffect(() => {
    if (roleQuery.isPending) {
      return;
    }
    const roles = roleQuery.data?.roles || [];
    if (roles.length === 0) {
      navigate({
        to: "/sign-in",
      });
      return;
    }
    const adminRole = roles.find(role => isAdminRole(role));
    const firstRole = roles[0]!;

    if (adminRole) {
      navigate({
        to: "/admin",
      });
      return;
    }
    if (isSupplierRole(firstRole)) {
      navigate({
        to: "/supplier/$supplierId",
        params: { supplierId: firstRole.supplier_id },
      });
      return;
    }
    if (isSupporterRole(firstRole)) {
      navigate({
        to: "/supporter/$supporterId",
        params: { supporterId: firstRole.supporter_id },
      });
      return;
    }
    // Unknown role, i'm kicking you out >:)
    navigate({
      to: "/sign-in",
    });
  }, [navigate, roleQuery.data, roleQuery.isError, roleQuery.isPending]);

  return (
    <Center css={{ width: "100%", height: "100%" }}>
      <Spinner />
    </Center>
  );
}
